import {
  ListOrganizationsResponse,
  OrganizationSummary,
  SchoolsApi,
} from 'services/api';

const MINIMAL_PAGE_SIZE = 200;
const MAX_PAGES = 5;

export async function listSchoolOrganizationsAll (
  schoolsApi: SchoolsApi,
  schoolId: string,
  options: { minimal?: boolean; includeInactive?: boolean } = { minimal: true },
): Promise<OrganizationSummary[]> {
  const organizations: OrganizationSummary[] = [];
  let cursor: string | null | undefined;
  let page = 1;

  while (page <= MAX_PAGES) {
    const result: Awaited<ReturnType<SchoolsApi['listOrganizations']>> =
      await schoolsApi.listOrganizations(schoolId, {
        page: cursor ? undefined : page,
        pageSize: MINIMAL_PAGE_SIZE,
        cursor: cursor || undefined,
        minimal: options.minimal !== false,
        includeInactive: options.includeInactive === true,
      });

    if (!result.success) {
      if (organizations.length === 0) throw new Error(result.error.message);
      break;
    }

    const batch: ListOrganizationsResponse = result.value;
    organizations.push(...(batch.organizations ?? []));
    cursor = batch.cursor;
    if (!cursor || (batch.organizations?.length ?? 0) === 0) break;
    page += 1;
  }

  return organizations;
}
